
import React, { Component, Fragment } from 'react'
import DragContainerUI from './DragContainerUI'
import DropItemContainerUI from './DropItemContainerUI'


class DragWordTiImgActivityUI extends Component {


    render = () => {

        let { activity, quizViewer } = this.props
        let { quizViwerModel } = quizViewer.state

        return (
            <Fragment>


                

                <DragContainerUI activity={activity} quizViewer={quizViewer} />
                <DropItemContainerUI  activity={activity} quizViewer={quizViewer} />


            </Fragment>
        )
    }

}

export default DragWordTiImgActivityUI